export default function Start({ next }: { next?: () => void }) {
    return (
        <div className='displayBox'>
          <h2>On Native Plants and Indigenous Uses</h2>
          <p>Harper K Davis</p>
          <br></br>
          <button className='mb-4' onClick={next}>Begin</button>
          <p className='little'>Honors The Southwest<br />Independent Research Project</p>
        </div>
    );
}